import { PageRef } from 'providers/page-ref';

export type NutritionOptionsPageParams = {};

export const INutritionOptionsPage: PageRef<NutritionOptionsPageParams, void> = {
  pageName: 'NutritionOptionsPage',
} as PageRef<NutritionOptionsPageParams, void>;
